import React from 'react';

import ReactDOM from 'react-dom';

import {Tree} from "@jd/find-react";


 

import KeeVue from '../base/KeeVue.js'

import $ from 'jquery';
import FeasComponents from '../render/FeasComponents.js'

const getTreeIcon =  (icon)=>{
	console.log("icon:"+icon);
	return <i className={`${icon}`}></i>
};

export default class FsTreeMenu extends KeeVue {
    constructor(props) {
        super(props);
        let body = null;
        if(this.props.component   && this.props.component?.child.length > 0) {
            body = this.props.component.child[0];
        }

        this.state = {
            isShow: false,
            randId: this.getRandString(),
            isShowMenu: false,
            toHide: false,
            bodyComponent: body,
            isScrolling: false,
            selectItem: {},
            propsTreeData: [],
            zTreeObj: null,
            treeTitle: "",

            filterUsers: [],
            selectItems: [],
            keyWord: '',
            isShowPlusBtn: true,
            isPositionOk: false,
            noDataToShow: true,
        }

    }

    componentDidMount() {
        this.registComponent();
		
		this.onEvent("refreshTreeMenu",this.refreshTreeMenu)
        this.initData();

    }
	
	refreshTreeMenu=()=>{
		
		if(this.props.from=='edit'&&!this.props.isShowMenu)
		{
			
			setTimeout(()=>{
						 let newTreeData = [];
						 this.initTreeStateData(this.props.treeData,"",newTreeData);
						 
						 this.originTree = this.props.treeData;
						 	 
						 this.newTreeData = newTreeData;
						 if(this.props.treeData &&typeof this.props.treeData!='undefined')
						 {
						 	 
						 	this.setState({
						 	    propsTreeData:[...newTreeData]
						 	})
						 }
			},100);
		}
		
		 
			
		
	}

	shouldComponentUpdate(nextProps,nextState)
	{
		//console.log("判断是否需要渲染tree");
		
		if(nextProps.from=='edit'&&!nextProps.isShowMenu)
		{
			console.log("判断是否需要渲染tree");
			return false;
		}
		
		if(this.lastStateString&& this.lastStateString == JSON.stringify(this.newTreeData)){
		//	console.log("不需要渲染");
		    return false;
		}
		this.lastStateString = JSON.stringify(this.newTreeData);
		
		//console.log("需要渲染");
		return true;
	}
	
    componentWillReceiveProps(nextProps, nextState) {
  
      // console.log("tree参数变更");
	    
		if(nextProps.from=='edit'&&!nextProps.isShowMenu)
		{
			return false;
		}
		
		if(this.props.component&&this.props.component.cp.url)
		{
			
		}
		else
		{
			let newTreeData = [];
			this.initTreeStateData(nextProps.treeData,"",newTreeData);
			
			this.originTree = nextProps.treeData;
				 
			this.newTreeData = newTreeData;
			if(nextProps.treeData &&typeof nextProps.treeData!='undefined')
			{
				 
				this.setState({
				    propsTreeData:[...newTreeData]
				})
			}
		}
		
		
		
		 
        
    }

    onSelect = (selectedKeys, e) => {
        // selectedKeys, e:{selected: bool, selectedNodes, node, event},
        //
        // this.state.selectItem = e.node;
        
        // this.sendViewEvent("select", e.node);
        // this.refresh();

        this.state.selectItem = e.node;
        
		 let originData = this.originTreeApi?this.originTreeApi:this.originTree;
		 
		let cnode  = this.getComponentById(e.node.key,originData);
		 
		if(cnode)
		{
			this.sendViewEvent("select", cnode);
			
			this.$emit("select", cnode);
		}
        
    }

    onDoubleClick = (e, node) => {
        //e.stopPropagation();
		// 需要转换一下
		
		let cnode  = this.getComponentById(node.key,this.originTree);
		
		
        this.$emit("dblClick", cnode);
    }
	 
    onEdit = (row) => {
        this.sendViewEvent("edit", row);
    }
    onDel = (row) => {
        this.sendViewEvent("del", row);
    }
    query = () => {
        this.initData();
    }
    initData = () => {
        let that = this;
        if (this.props.component&&this.props.component.cp.url) {
            this.doRequest(this.props.component.cp.url,   (data)=> {
				
				
                 
                if (data) {
                    that.state.selectItems = [];
					let newTreeData = [];
					this.originTreeApi = data;
					 
                    that.initTreeStateData(data, that.props.component.value,newTreeData);
                    that.state.propsTreeData = newTreeData;
					
					//alert(JSON.stringify(newTreeData));
                    that.refresh();
                }
                 
            }, {})
        }
    }
    initTreeStateData = (data, roleIds,newTreeData) => {
		if(!data)
		{
			return ;
		}
        for (let i = 0; i < data.length; i++) {
			let node ={}
            node.title = data[i].title ;
			
			if(!node.title)
			{
				node.title = data[i].text;
			}
			
            node.key = data[i].id;
			if(data[i].attributes&&data[i].attributes.icon)
			{
				node.icon=getTreeIcon(data[i].attributes.icon);
			}
			
			//node.icon={<i className={data[i].icon}></i>};
            if (roleIds   && roleIds.indexOf(data[i].value) !== -1) {
                node.checked = true;
                this.state.selectItems.push(node);
            } else {
                node.checked = false;
            }
             
            this.noDataToShow = false;
            if (node.state === "open")
                node.showChild = true;
            else
                node.showChild = false;
            // if (data[i].child) {
            //     node.children = data[i].child;

            // }
            if(data[i].child)
            {
				let children =[];
                this.initTreeStateData(data[i].child, roleIds,children);
				
				node.children = children;
            }
			else
			if(data[i].children)
			{
				data[i].child = data[i].children;
				
				let children =[];
				this.initTreeStateData(data[i].children, roleIds,children);
				
				node.children = children;
			}
			if(typeof newTreeData !=="undefined")
			{
				newTreeData.push(node);
			}
			

        }
    }
	
	onDrop=(info)=>{
		 
		if(this.props.canDrop===true||this.props.component.cp.canDrop)
		{
			console.log("treeinfo",info);
			
			this.$emit("drop",info);
		 
			
			this.sendPageEvent("drop", info,this.state.propsTreeData);
			
		}
		
	}
	
	refreshTree=(newTreeData)=>{
		
		this.setState({
		    propsTreeData:[...newTreeData]
		})
		
	}

    render() {
        console.log("xuan ran tree menu")
       
        return (

            <div> 
			 
                <Tree
				showIcon
                    onSelect={this.onSelect}
                    onDoubleClick={this.onDoubleClick}
					onDrop={this.onDrop}
                    draggable={this.props.canDrop==true||this.props.component.cp.canDrop}
                    blockNode={true}
                    treeData={this.state.propsTreeData}
                />

            </div>
        );
    }
}



